export default{

    title: 'Success',
    updated: 'The information was updated successfully!',
    created: 'Creation was successful',
    deleted: 'The deletion was executed successfully!'
}